import { useEffect, useState } from 'react';
import JsBarcode from 'jsbarcode';
import { getPharmacyInfo } from '../../service/pharmacy.service';
import { useLocation } from 'react-router-dom';
import { getAllCustomerInfo } from '../../service/allCustomerInfo.service';
import moment from 'moment';
import { goTo } from '../../utilities/common.utilities';
import ImageWithErrorHandling from '../Shared/ImageWithErrorHandling/imageWithErrorHandling.component';
import { useConnectivity } from '../../context/connectivityContext';


type Card = {
    selectedCard: string;
    cardPrefix: string;
    groupCode: string;
    storeCode: string;
    barCode: string;
    coverCard: string;
}
export default function FidelityCard () {
  const location = useLocation()

  // Se non sono presenti dati in location.state, reindirizzo in home al posto
  // di far andare in errore il componente
  if(!location.state) {
    goTo('/home');
  }

  const { cardData } = location.state;
  const [card, setCard] = useState<Card | null>({
    selectedCard: '',
    cardPrefix: '',
    groupCode: '',
    storeCode: '',
    barCode: '',
    coverCard: '',
  });
  const [historyPoints, setHistoryPoints] = useState<any[]>([]); // creare model per historyPoints
  const [viewHistoryPoints, setViewHistoryPoints] = useState<boolean>(false);
  const [indexToShow, setIndexToShow] = useState<number>(5);
  const [endGetHistory, setEndGetHistory] = useState<boolean>(false);
  const { isOnline } = useConnectivity();

  const getInfo = () => {
    let response:Card | null;
    getPharmacyInfo(cardData.groupCode, cardData.storeCode, cardData.selectedCard).then((pharmacyInfo) => {

        if(pharmacyInfo?.length > 0 && pharmacyInfo[0].stores?.length > 0) {

            let cardPrefix: string = pharmacyInfo[0]?.stores[0]?.cardPrefix ?? '';

            response = {
                selectedCard: cardData?.selectedCard,
                cardPrefix: pharmacyInfo[0]?.stores[0]?.cardPrefix ?? '',
                groupCode: cardData?.groupCode,
                storeCode: cardData?.storeCode,
                barCode: textToBase64Barcode(cardPrefix + cardData?.selectedCard),
                coverCard: pharmacyInfo[0]?.stores[0]?.cardImage.replace('/storage','')
            } as Card

            setCard(response);

        }
        else {

            let cardPrefix: string = '';

            response = {
                selectedCard: cardData?.selectedCard,
                cardPrefix: cardPrefix,
                groupCode: cardData?.groupCode,
                storeCode: cardData?.storeCode,
                barCode: '',
                coverCard: ''
            } as Card
            setCard(response);
        }
        
    });
 
};

    const getHistoryPoints = () => {
        getAllCustomerInfo(cardData.groupCode, cardData.storeCode, cardData.selectedCard).then(allCustomerInfo => {
            if(allCustomerInfo?.points?.points.length > 0){
                const tempList = allCustomerInfo.points.points.map((item:any) => { // creare Model per la lista dei punti
                    return {
                        date: item.creationDate.split(".")[0].replace("T", " ").replaceAll("-", "/"),
                        points: item.points,
                        isPositive: item.points >= 0 ? true : false,
                        description: item.pointType.description
                    }
                })
                setHistoryPoints(tempList);
            } else {
                setHistoryPoints([]);
            }
            setEndGetHistory(true)
        });
    }

    const textToBase64Barcode = (text: string) => {
        var canvas = document.createElement("canvas");
        JsBarcode(canvas, text, {format: "CODE128",width: 5,background:'white', displayValue: false});
        
        return canvas.toDataURL("image/png");
      }

    useEffect( () => {
        getInfo();
        setViewHistoryPoints(false);
        getHistoryPoints();
    }, [isOnline]); // Indico di reindirizzare il componente quando la variabile isOnline cambia valore

    const mostraImmagineDefault = (e: any): void => {
        let imgTag: any = e.target;

        imgTag.setAttribute('src', 'Fidelity-salus-card.png')
    }

   const showMoreHistoryPoints = () =>{
        setIndexToShow(historyPoints.length); 
        setViewHistoryPoints(true)
       
    }

    const sectionCard = () => {
        return (
            card && card.barCode
            ?
            <div className="flex flex-wrap align-items-center justify-content-center bg-white barcodeCardContainer">

                {/* <img id='fidelityCard' className='barcodeCard' src={card.barCode} alt="Barcode"/>  */}
                <ImageWithErrorHandling src={card.barCode} alt="Barcode" classes='barcodeCard'/>


                <div className='flex justify-content-center'>
                    <div className='flex align-items-center justify-content-center text-2xl barCodeNumber'>
                        { card.cardPrefix + localStorage.getItem("selectedCard")}
                    </div>
                </div>
            </div>
            :
            <></>
        )
    }


        return (
            <>
                    <div className='flex justify-content-center'>
                        <h2 className='mt-1'>Fidelity Card</h2>
                    </div>
                    <div className="flex justify-content-center">
                        {
                            endGetHistory ?
                            sectionCard()
                            :
                            <></>
                        }
                    </div>

                    {
                        card
                        ?
                        <div className="flex justify-content-center mt-5">
                            <div className="flex flex-wrap align-items-center justify-content-center">
                                <div className=" flex align-items-center justify-content-center font-bold m-2">
                                    { card.coverCard ? 
                                        <img onError={ (e)=> mostraImmagineDefault(e)} id='fidelityCard' src={process.env.REACT_APP_STORAGE_URL + card.coverCard} className='coverCard' alt="CoverCard"/> 
                                    :
                                        <img src="Fidelity-salus-card.png" className='coverCard' alt="CoverCard" />
                                    }
                                        
                                </div>
                            </div>
                        </div>
                        : <></>
                    }



                <div className='mt-5 mx-1'>
                    

                    <div className='bg-primary mb-5' style={{borderRadius: '6px'}} >
                        <div className="flex justify-content-between font-bold p-3" style={{cursor:'pointer'}} onClick={() => setViewHistoryPoints(!viewHistoryPoints)}>
                        <div className="flex align-items-center justify-content-left" style={{fontSize: '14px'}}>
                            STORICO PUNTI
                        </div>

                        <div className="flex align-items-center justify-content-right">
                        {!viewHistoryPoints
                            ? <i className='pi pi-eye' style={{fontSize: '14px'}}/>
                            : <i className='pi pi-eye-slash' style={{fontSize: '14px'}}/>
                            }
                        </div>
                        </div>
                        

                        { viewHistoryPoints ? 
                            // <ScrollPanel style={{ width: '100%', height: historyPoints.length > 0 ? '200px' : '46px', border: '1px solid #189cd8', borderTop: '0px' }} className="mt-1">
                             <div className="flex justify-content-center bg-white"  style={{color: 'black'}}>
                                <div className="flex flex-wrap align-items-center justify-content-center">

                                 { historyPoints.length > 0 ? 
                                    historyPoints.map( (item, index) => 
                                         index < indexToShow ?
                                            <div className="flex justify-content-between w-full font-bold p-3">
                                                <div className="flex-1 align-items-center justify-content-start py-3">
                                                    <div className='flex-column'>
                                                        <div>{moment(item.date).format('DD/MM/YYYY')}</div>
                                                        <div>{moment(item.date).format('HH:mm')}</div>
                                                    </div>
                                                </div>
                                                <div className={ !item.isPositive ? 'flex-1 align-items-center justify-content-center px-2 py-3 text-orange-500' : 'flex-1 align-items-center justify-content-center px-2 py-3 text-green-500'}>
                                                        {item.points + ' punti'}
                                                </div>
                                                <div className="flex-1 align-items-center justify-content-center px-2 py-3">
                                                        {item.description}
                                                </div>
                                            </div>
                                            : index === 5 ?
                                                <div className='flex-column text-center p-2' style={{cursor:'pointer'}} onClick={() => showMoreHistoryPoints()}>
                                                    <div className='align-items-center justify-content-center p-2 font-bold' style={{fontSize: '1rem'}}>Mostra di più</div>
                                                    <div className='align-items-center justify-content-center p-2 font-bold pi pi-angle-down' style={{fontSize: '1.5rem'}}></div>
                                                </div>
                                            : <></>
                                )
                                
                                : <div className='p-3'>Non è presente uno storico per questa carta</div>
                            }

                                    {indexToShow === historyPoints.length ?
                                        <div className='text-center'>Hai raggiunto la fine della tua lista</div>
                                        : <></>
                                    }

                                </div>
                            </div>
                         : <></>
                        }
                        
                    </div>

                    

                </div>
                


        </>     
        );



}